const beautify = require("../../beautify");

$(function(){






    let landownnersOrderListElem = $('#landowner-order-list');
    if(landownnersOrderListElem.length > 0){
        $('.filters-landowner-order-list').on('change', 'input', function(e){
            loadLandownnersOrderList(landownnersOrderListElem);
        })
        loadLandownnersOrderList(landownnersOrderListElem);
    }
function loadLandownnersOrderList(landownnersOrderListElem) {
    $.ajax({
        url: landownnersOrderListElem.data('url'),
        data: $('.filters-landowner-order-list').serializeJSON(),
        method: 'GET',
        success: function(response) {
            if (!response.data || response.data.length === 0) {
                landownnersOrderListElem.html(`
                    <div class="empty-message" style="text-align:center; padding: 2rem; color: #666;">
                        <img src="${url+'/storage/frontend/paint-roller.svg'}" alt="No orders" style="width:100px; margin-bottom: 1rem; opacity: 0.5">
                        <div>No orders found</div>
                        <div>Click the button below to request a service</div>
                        <a href="${url+'/products'}" class="btn btn-primary mt-3">Request a service</a>
                    </div>
                `);
                return;
            }

            let html = '';
            $.each(response.data, function(_, order) {
                const displayAmount = order.due > 0 ? order.due : order.total_paid;
                const orderBidCountCaption = order.biddings_count > 0 ? `${order.biddings_count} offer` : '';
                let topRight = '';
                let middle = '';
                let bottomRight = '';

                if (order.type === 'one_time_bidding') {
                    if (order.order_status === 'in_progress' && order.due <= 0) {
                        // Blink green dot for active in-progress orders
                        topRight = '<i class="fas fa-circle fa-beat-fade text-success"></i>';
                        middle = orderBidCountCaption;
                        bottomRight = ''; // nothing
                    } else {
                        // Completed / not in-progress bidding
                        topRight = beautify.badge(order.payment_status ?? 'pending', order.payment_status);
                        middle = order.currency_symbol + displayAmount;
                        bottomRight = orderBidCountCaption;
                    }
                } else {
                    // Normal orders
                    topRight = beautify.badge(order.payment_status ?? 'pending', order.payment_status);
                    middle = orderBidCountCaption || order.currency_symbol + displayAmount;
                    bottomRight = '';
                }

                const timeRange = order.requested_timerange ? ' • ' + order.requested_timerange : '';

                html += `
                    <a href="${url+'/order/details/'+order.uuid}" class="list-card list-card-bg-hover d-flex position-relative">
                        <div>
                            <img class="card-order-icon" src="${url+'/storage/' + order.product_icon}" height="48" width="48">
                        </div>
                        <div class="list-card-info">
                            <div class="list-card-title">${order.product_name} • ${beautify.reverseSlug(order.type)}</div>
                            <div class="list-card-date">
                                <span class="ml-2 text-muted card-time">
                                    <i class="fa-regular fa-calendar-check"></i>
                                    ${beautify.date_format(order.requested_date)}${timeRange}
                                </span>

                                <span class="ml-2 text-muted card-location">
                                    <i class="fa-solid fa-map-pin"></i>
                                    ${order.address}
                                </span>

                            </div>
                            <div class="list-card-message d-flex flex-wrap gap-2 mt-1">
                                <span class="text-nowrap small">${beautify.badge('#'+order.reference, 'secondary')}</span>
                                <span class="text-nowrap small">${beautify.badge(order.order_status, order.order_status)}</span>
                            </div>
                        </div>
                        <div class="list-card-right">
                            <div class="list-card-amount text-primary middle">
                                ${middle}
                            </div>

                            <div class="top-right">
                                ${topRight}
                            </div>
                            <div class="bottom-right">
                                ${bottomRight}
                            </div>
                        </div>
                    </a>
                `;
            });

            landownnersOrderListElem.html(html);
        }
    });
}





    let maintainerOrderListElem = $('#maintainer-order-list');
    if(maintainerOrderListElem.length > 0){
        $('.filters-maintainer-order-list').on('change', 'input', function(e){
            loadMaintainerOrderList(maintainerOrderListElem);
        })
        loadMaintainerOrderList(maintainerOrderListElem);
    }


    function loadMaintainerOrderList(maintainerOrderListElem){
        maintainerOrderListElem.html(`
            <div class="center mt-5">${beautify.loading('Loading...')}</div>
        `);
        $.ajax({
            url: maintainerOrderListElem.data('url'),
            method: 'GET',
            data: $('.filters-maintainer-order-list').serializeJSON(),
            success: function(response){
                if(response.data.length == 0){
                    maintainerOrderListElem.html(`
                    <div class="empty-message" style="text-align:center; padding: 2rem; color: #666;">
                        <img src="${url+'/storage/frontend/home-2.svg'}" alt="No orders" style="width:100px; margin-bottom: 1rem; opacity: 0.5">
                        <div>No orders found</div>
                    </div>
                    `);

                    return true;
                }
                let html = '';
                $.each(response.data, function(index, value){
                    let displayAmount = value.type == 'one_time_bidding' ? 'BID <i class="fa fa-arrow-right"></i>' :
                                value.currency_symbol + (value.maintainer_amount ?? 0);
                    if(value.order_status == 'task_done'){
                        displayAmount = value.currency_symbol + (value.maintainer_amount ?? 0);
                    }
                    let timeRange = value.requested_timerange ? '<i class="fa-regular fa-clock"></i> ' + value.requested_timerange : '';
                    html += `<a href="${url+'/order/maintainer/details/'+value.uuid}" class="list-card list-card-bg-hover d-flex position-relative">
                        <div>
                            <img class="card-order-icon" src="${url+'/storage/' + value.product_icon}" height="48" width="48">
                        </div>
                        <div class="list-card-info">
                            <div class="list-card-title">${value.product_name} • ${beautify.reverseSlug(value.type)}</div>
                            <div class="list-card-date">
                                ${beautify.badge(value.order_status)}
                                <span class="badge badge-secondary">#${value.reference}</span>
                            </div>
                            <div class="list-card-message d-flex flex-wrap gap-2 mt-1">
                                <span class="text-muted">
                                    <span class="text-nowrap">
                                    Booking Date: <span class="b">${beautify.date_format(value.requested_date)}</span>
                                    </span>
                                    <span class="text-nowrap">
                                        ${timeRange}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div class="list-card-amount text-primary">
                            ${displayAmount}
                        </div>
                        <div class="top-right">
                            ${ value.duration > 0 ? beautify.badge(value.duration+' Hour') : '' }
                        </div>
                    </a>`
                })
                maintainerOrderListElem.html(html);
            }
        })
    }



    $(document).on('click', '#maintenance-complete', function(e){
        e.preventDefault();

        let imagesRaw = $('#maintenance-complete-images').val();
        let images = [];

        try {
            images = JSON.parse(imagesRaw);
        } catch (error) {
            console.log(error);
            return;
        }
        var action = $(this).data('action');
        if (!Array.isArray(images) || images.length === 0) {
            beautify.sweetConfirm('You want to proceed without uploading images?', 'we always recomend you to upload images', function (confirm) {
                if (confirm) {

                    maintenanceComplete(action);

                }
            }, 'Yes', 'No');
        }else{
            maintenanceComplete(action, imagesRaw);
        }

    })

    function maintenanceComplete(action, imagesRaw = ''){
        var payload = {
            images: imagesRaw,
            _token: $('meta[name="csrf-token"]').attr('content')
        };
        $.ajax({
            url: action,
            method: 'POST',
            data: payload,
            success: function(response){
                if(response.status == 'success'){
                    location.reload();
                }else{
                    beautify.notification(response.message, response.status);
                }
            },
            error: function(responnse){
                beautify.notification(responnse.message, responnse.status);
            }
        });
    }

});
